define('plugin/tips/view/TipsCustomDialogView',['require','lib/view/LayoutView'],function (require) {

    var LayoutView = require('lib/view/LayoutView');

    /**
     * Tips custom dialog view
     *
     * @class TipsCustomDialogView
     */
    return LayoutView.extend({

        template: '#tips_custom_dialog_view',
        ui: {
            confirmBtn: '#sb_tips_custom_confirm',
            amount: '#sb_tips_custom_amount',
        },

        events: {
            'click @ui.confirmBtn': 'setCustomTip'
        },
        triggers: {
            // 'click @ui.confirmBtn': {
            //     'event': 'confirm',
            //     'preventDefault': false,
            //     'stopPropagation': false
            // }
        },

        serializeData: function () {
            var result = Marionette.LayoutView.prototype.serializeData.apply(this);

            if(!result.amount) {
                result.amount = 0;
            }
            if(this._error) {
                result.error = this._error;
            }
            return result;
        },


        setCustomTip: function () {
            this._error = null;
            var amount = this.ui.amount.val();

            if(!amount || amount < 0) {
                this._error = 'Please enter a valid amount';
                this.render();
                return;
            }

            this.model.set('amount', amount);
            this.triggerMethod('confirm');
        }

    });

});
